import {
    API
} from '../Api.class';
import {
    AdPlacementsAPI
} from './AdPlacementAnalytics.api';
// import {
//     InventoryStatsAPI
// } from './InventoryStats.api';


export class AdPlacementAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

        this.Analytics = new AdPlacementsAPI(baseUrl);
    }


    async list(pagination, filter, meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/ad-placements', {
            meta,
            params: {
                ...pagination,
                ...filter
            }
        })
    }

    async get(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/ad-placements/${id}`, {
            meta
        });

    }

    async create(body, meta) {
        this.loading = true;

        return await this.__axiosInstance.post('api/v1/ad-placements', body, {
            meta
        });
    }
    async update(item, meta) {
        this.loading = true

        return await this.__axiosInstance.put(`api/v1/ad-placements/${item.id}`, item, {
            meta
        });
    }

    async delete(itemId, meta) {
        this.loading = true

        return await this.__axiosInstance.delete(`api/v1/ad-placements/${itemId}`, {
            meta
        });
    }
}